/* ====================================================
   FLEN Product Page — Phase 2 JS
   ==================================================== */

(function() {
  'use strict';

  /* ── 1. GALLERY ── */
  var slides = document.querySelectorAll('.fp-slide');
  var dots = document.querySelectorAll('.fp-dot');
  var counter = document.getElementById('flenGCounter');
  var cur = 0;
  var tot = slides.length;

  function goTo(n) {
    if (tot === 0) return;
    if (n < 0) n = tot - 1;
    if (n >= tot) n = 0;
    slides[cur].classList.remove('on');
    if (dots[cur]) dots[cur].classList.remove('on');
    cur = n;
    slides[cur].classList.add('on');
    if (dots[cur]) dots[cur].classList.add('on');
    if (counter) counter.textContent = (cur + 1) + ' / ' + tot;
  }

  var gPrev = document.getElementById('flenGPrev');
  var gNext = document.getElementById('flenGNext');
  if (gPrev) gPrev.addEventListener('click', function() { goTo(cur - 1); });
  if (gNext) gNext.addEventListener('click', function() { goTo(cur + 1); });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      goTo(parseInt(dot.getAttribute('data-index'), 10));
    });
  });

  /* Touch swipe */
  var gallery = document.getElementById('flenGallery');
  if (gallery) {
    var touchStartX = 0;
    gallery.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 35) {
        goTo(dx < 0 ? cur + 1 : cur - 1);
      }
    }, { passive: true });
  }


  /* ── 2. STICKY ATC BAR ── */
  var atcBtn = document.getElementById('flenAtcBtn');
  var stickyBar = document.getElementById('flenStickyBar');

  if (atcBtn && stickyBar) {
    window.addEventListener('scroll', function() {
      var rect = atcBtn.getBoundingClientRect();
      if (rect.bottom < 60) {
        stickyBar.classList.add('show');
      } else {
        stickyBar.classList.remove('show');
      }
    }, { passive: true });
  }


  /* ── 3. FAQ ACCORDION ── */
  /* Extend existing flenAccordion to handle .flen-faq-item */
  window.flenAccordion = function(btn) {
    var item = btn.closest('.flen-why-item, .flen-faq-item, .why-item, .faq-item');
    if (!item) return;
    var isOpen = item.classList.contains('open');
    var parent = item.parentElement;
    if (parent) {
      parent.querySelectorAll('.open').forEach(function(i) {
        i.classList.remove('open');
      });
    }
    if (!isOpen) {
      item.classList.add('open');
    }
  };


  /* ── 4. ATC FORM INTERCEPT ── */
  var productForm = document.getElementById('flenProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = document.getElementById('flenVariantId');
      if (!variantId) return;

      var formData = {
        items: [{
          id: parseInt(variantId.value, 10),
          quantity: 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        /* Open cart drawer */
        var cartOverlay = document.getElementById('flenCartOverlay');
        var cartDrawer = document.getElementById('flenCartDrawer');
        if (cartDrawer && cartOverlay) {
          cartDrawer.classList.add('on');
          cartOverlay.classList.add('on');
          document.body.style.overflow = 'hidden';
        }
        /* Refresh cart */
        if (typeof window.flenCartChange === 'function') {
          /* Trigger a re-fetch by changing nothing (hack) */
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              /* Update cart count badges */
              document.querySelectorAll('.flen-cart-count').forEach(function(el) {
                if (cart.item_count > 0) {
                  el.textContent = cart.item_count;
                  el.style.display = 'flex';
                } else {
                  el.style.display = 'none';
                }
              });
              /* Render cart items if fn exists */
              var container = document.getElementById('flenCartItems');
              var totalEl = document.getElementById('flenCartTotal');
              var footerEl = document.getElementById('flenCartFooter');
              if (container) {
                renderCartDrawer(cart, container, totalEl, footerEl);
              }
            });
        }
      })
      .catch(function(err) {
        console.error('FLEN ATC error:', err);
      });
    });
  }

  function formatMoney(cents) {
    return '\u20B9' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function escHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  function renderCartDrawer(cart, container, totalEl, footerEl) {
    if (!cart.items || cart.items.length === 0) {
      container.innerHTML = '<div class="flen-cart-empty">Your cart is empty</div>';
      if (totalEl) totalEl.textContent = formatMoney(0);
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (footerEl) footerEl.style.display = '';
    var html = '';
    cart.items.forEach(function(item) {
      var imgSrc = '';
      if (item.image) {
        imgSrc = item.image.indexOf('?') > -1 ? item.image + '&width=140' : item.image + '?width=140';
      }
      var variantTitle = item.variant_title || '';
      html += '<div class="flen-ci">';
      html += '  <div class="flen-ci-img">';
      if (imgSrc) html += '    <img src="' + imgSrc + '" alt="' + escHtml(item.title) + '" loading="lazy">';
      html += '  </div>';
      html += '  <div class="flen-ci-info">';
      html += '    <div class="flen-ci-name">' + escHtml(item.product_title) + '</div>';
      if (variantTitle) html += '    <div class="flen-ci-variant">' + escHtml(variantTitle) + '</div>';
      html += '    <div class="flen-ci-bottom">';
      html += '      <div class="flen-ci-qty">';
      html += '        <button onclick="flenCartChange(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease">\u2212</button>';
      html += '        <span>' + item.quantity + '</span>';
      html += '        <button onclick="flenCartChange(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase">+</button>';
      html += '      </div>';
      html += '      <div class="flen-ci-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '    </div>';
      html += '    <a href="#" class="flen-ci-remove" onclick="flenCartChange(\'' + item.key + '\', 0); return false;">Remove</a>';
      html += '  </div>';
      html += '</div>';
    });
    container.innerHTML = html;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }


  /* ── 5. VARIANT SELECTION ── */
  var variantsJson = document.getElementById('flenProductJson');
  var variants = [];
  if (variantsJson) {
    try { variants = JSON.parse(variantsJson.textContent); } catch(e) {}
  }

  var variantBtns = document.querySelectorAll('.fp-variant-btn');
  if (variantBtns.length > 0 && variants.length > 0) {
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optIdx = parseInt(btn.getAttribute('data-option-index'), 10);
        /* Deactivate siblings */
        var group = btn.closest('.fp-variant-options');
        if (group) {
          group.querySelectorAll('.fp-variant-btn').forEach(function(b) {
            b.classList.remove('active');
          });
        }
        btn.classList.add('active');

        /* Build selected options array */
        var selectedOptions = [];
        document.querySelectorAll('.fp-variant-group').forEach(function(g) {
          var active = g.querySelector('.fp-variant-btn.active');
          if (active) selectedOptions.push(active.getAttribute('data-value'));
        });

        /* Find matching variant */
        var matched = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opts = v.options || [];
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (opts[j] !== selectedOptions[j]) { match = false; break; }
          }
          if (match) { matched = v; break; }
        }

        if (matched) {
          /* Update hidden input */
          var idInput = document.getElementById('flenVariantId');
          if (idInput) idInput.value = matched.id;

          /* Update price display */
          var priceNow = document.getElementById('flenPriceNow');
          var priceCompare = document.getElementById('flenPriceCompare');
          var saveBadge = document.getElementById('flenSaveBadge');
          var stickyNow = document.getElementById('flenStickyNow');
          var stickyCompare = document.getElementById('flenStickyCompare');

          if (priceNow) priceNow.textContent = formatMoney(matched.price);
          if (stickyNow) stickyNow.textContent = formatMoney(matched.price);

          if (matched.compare_at_price && matched.compare_at_price > matched.price) {
            if (priceCompare) {
              priceCompare.textContent = formatMoney(matched.compare_at_price);
              priceCompare.style.display = '';
            }
            if (saveBadge) {
              saveBadge.textContent = 'Save ' + formatMoney(matched.compare_at_price - matched.price);
              saveBadge.style.display = '';
            }
            if (stickyCompare) {
              stickyCompare.textContent = formatMoney(matched.compare_at_price);
              stickyCompare.style.display = '';
            }
          } else {
            if (priceCompare) priceCompare.style.display = 'none';
            if (saveBadge) saveBadge.style.display = 'none';
            if (stickyCompare) stickyCompare.style.display = 'none';
          }

          /* Update ATC button */
          var atcBtnEl = document.getElementById('flenAtcBtn');
          if (atcBtnEl) {
            if (matched.available) {
              atcBtnEl.disabled = false;
              atcBtnEl.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>Add to Cart';
            } else {
              atcBtnEl.disabled = true;
              atcBtnEl.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>Sold Out';
            }
          }

          /* Update Buy Now link */
          var buyNowEl = document.getElementById('flenBuyNow');
          if (buyNowEl) {
            buyNowEl.href = '/cart/' + matched.id + ':1';
          }

          /* Update sticky Buy Now link */
          var stickyBuyEl = document.getElementById('flenStickyBuy');
          if (stickyBuyEl) {
            stickyBuyEl.href = '/cart/' + matched.id + ':1';
          }

          /* Update URL */
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', matched.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
      });
    });
  }

  /* ── Buy Now button click (direct to checkout) ── */
  var buyNowBtn = document.getElementById('flenBuyNow');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var vid = document.getElementById('flenVariantId');
      if (vid) {
        window.location.href = '/cart/' + vid.value + ':1';
      }
    });
  }

  var stickyBuyBtn = document.getElementById('flenStickyBuy');
  if (stickyBuyBtn) {
    stickyBuyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var vid = document.getElementById('flenVariantId');
      if (vid) {
        window.location.href = '/cart/' + vid.value + ':1';
      }
    });
  }



  /* ====================================================
     CRO v4 — 30min Timer + CTA Feedback
     ==================================================== */

  /* ── 30-MINUTE COUNTDOWN TIMER ── */
  var timerEl = document.getElementById('flenOfferTimer');
  if (timerEl) {
    var timerKey = 'flen_timer_end';
    var stored = null;
    try { stored = sessionStorage.getItem(timerKey); } catch(e) {}

    var endTime;
    if (stored && parseInt(stored, 10) > Date.now()) {
      endTime = parseInt(stored, 10);
    } else {
      endTime = Date.now() + (30 * 60 * 1000); /* 30 minutes */
      try { sessionStorage.setItem(timerKey, endTime); } catch(e) {}
    }

    function updateTimer() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        timerEl.textContent = '00:00';
        timerEl.style.color = '#e74c3c';
        return;
      }
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      timerEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  }

  /* ── ATC SUCCESS FEEDBACK ── */
  var croAtcBtn = document.getElementById('flenAtcBtn');
  if (croAtcBtn) {
    var origAtcHtml = croAtcBtn.innerHTML;
    var croForm = document.getElementById('flenProductForm');
    if (croForm) {
      croForm.addEventListener('submit', function() {
        croAtcBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Added!';
        croAtcBtn.style.background = '#f0fdf4';
        croAtcBtn.style.borderColor = '#15803d';
        croAtcBtn.style.color = '#15803d';
        setTimeout(function() {
          croAtcBtn.innerHTML = origAtcHtml;
          croAtcBtn.style.background = '';
          croAtcBtn.style.borderColor = '';
          croAtcBtn.style.color = '';
        }, 2000);
      });
    }
  }

})();
